module.exports = __webpack_public_path__ + "img/empty_thumnail.c10512f7.jpg";